import { useEffect, useState } from "react";
import { useGetTransportationTypes } from "../../../../../../api/static-data";
import { WEIGHT_UNIT_TYPES_OPTIONs } from "../../../../../../config/optionsConstants";
import { InternalTransportOriginalSnapshot, InternalTransportToolVariant } from "../internalTransport.types";
import { mapTransportationTypesToOptions } from "../internalTransport.utils";

interface UseInternalTransportSimulateCompareOptions {
  variant: InternalTransportToolVariant;
  originalTransportData: any;
}

export const useInternalTransportSimulateCompare = ({
  variant,
  originalTransportData
}: UseInternalTransportSimulateCompareOptions) => {
  const [originalSnapshot, setOriginalSnapshot] =
    useState<InternalTransportOriginalSnapshot | null>(null);

  const { data: transportationTypesData, isSuccess: transportationTypesSuccess } =
    useGetTransportationTypes();

  useEffect(() => {
    if (variant !== "simulate" || !originalTransportData || !transportationTypesSuccess) {
      return;
    }

    setOriginalSnapshot({
      transportName: originalTransportData.internalTransportName || "",
      avgDistance: originalTransportData.averageDistance || "",
      transportType:
        mapTransportationTypesToOptions(transportationTypesData)?.find(
          item => String(item.value) === String(originalTransportData.transportationType)
        )?.text || "",
      weight: originalTransportData.weight || "",
      weightUnit:
        WEIGHT_UNIT_TYPES_OPTIONs.find(unit => unit.value === originalTransportData.weightUnit)
          ?.text || ""
    });
  }, [originalTransportData, transportationTypesData, transportationTypesSuccess, variant]);

  const isSimulateCompare = variant === "simulate" && Boolean(originalSnapshot?.transportName);

  return { originalSnapshot, isSimulateCompare };
};
